import React, { useEffect, useState } from 'react';
import html2pdf from 'html2pdf.js';
import '../App.css';
import { BASE_URL } from "../utils/config";
import FutureBuyReport from '../components/futurebuyReport';
import FutureSellReport from '../components/futuresellReport';
import OptionsPutReport from '../components/optionPutReport';
import OptionCallReport from '../components/optionCallReport';
import DeliveryReport from '../components/DeliveryReport';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import { useNavigate } from "react-router-dom";

import Loading from '../components/loading'
import { faBedPulse } from '@fortawesome/free-solid-svg-icons';
const Report = (props) => {
    
    const navigate = useNavigate();
    const {setEventChange,onSuccessSubmit} = props
    const checked = props.reportChecked
    const eventType = props.eventType;
    const reportDate = props.reportDate;
    const imageUrl = props.imageUrl;
    const imageBuffer = props.imageBuffer;
    const futureSectionState = props.eventType ==='Future'? props.SectionState : {};
    const optionSectionState = props.eventType ==='Options'? props.SectionState : {};
    const deliverySectionState = props.eventType ==='Delivery' || props.eventType ==='HNI' ? props.SectionState : {};
    const stockLossRecord = props.stockLossRecord;
    const selectedExpiryRecord = props.selectedExpiryRecord;
    const selectedStockRecord = props.selectedStockRecord;
    const [ReportData, setReportData] = useState({});
    const [loginuser,setLoginuser]=useState({});
    const [loading,setLoading]=useState(false);
    const [isSaveReportSuccessful, setIsSaveReportSuccessful] = useState(false);
    const [ReportError,setReportError]= useState(false)
    const [ReportSuccess,setReportSuccess]= useState(false)
    const [dialogBox,setDialogBox]=useState(false);
    const [reportCreated,setReportCreated]=useState(false);
    const [showErrorMsz,setShowErrorMsz]=useState(false);
    const [errorMessage,setErrorMessage]=useState('');
    const [ReportAlreadySuccess,setReportAlreadySuccess]= useState(false);
   
    let count = 0;
    let formattedDate = '';
    let formattedTime = '';

    useEffect(() => {
        if (count === 0) {
            const currentDate = new Date();

            // Get date components
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
            const day = currentDate.getDate();

            // Get time components
            const hours = currentDate.getHours();
            const minutes = currentDate.getMinutes();
            const seconds = currentDate.getSeconds();

            // Format date and time
            formattedDate = `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;

            // console.log("formatesd date", formattedDate)
            formattedTime = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;

            // console.log("formattedTime", formattedTime)
             
            let loginuser = JSON.parse(localStorage.getItem("loginData"));
            setLoginuser(loginuser);
            // submitForm();
            count += 1;
        }

    }, [])


    // this function is used to download future buy report
    const futurebuydownloadPDF = (elementId, formattedDate, formattedTime) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `future_buy_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    };

    //  this function is used to download future sell report 
    const futureselldownloadPDF = (elementId, formattedDate, formattedTime) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)
            if (element) {
                const pdfOptions = {
                   margin: 5,
                    filename: `future_sell_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    };

      //  this function is used to download option call report 
    const optioncalldownloadPDF = (elementId, formattedDate, formattedTime) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                   margin: 5,
                    filename: `option_call_report${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    };

    //  this function is used to download option put report 
    const optionputdownloadPDF = (elementId, formattedDate, formattedTime) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                   margin: 5,
                    filename: `option_put_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    };

    //  this function is used to downlaod delivery report 
    const deliveryreportdownloadPDF = (elementId, formattedDate, formattedTime) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                   margin: 5,
                    filename: `delivery_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    };

//  this function is used to send report to telegram
    const sendtotelegram = () => {
        try{
        setLoading(true)
      
        let data 
        if(eventType === 'Future'){
            data = JSON.stringify({ReportData:ReportData,commentery:checked === true ?'YES':'NO',isMCX:true});
        }else if(eventType === 'Options'){
            data = JSON.stringify({ReportData:ReportData,commentery:checked === true ?'YES':'NO',intraday:false,Free:false}); 
        }
        else if(eventType === 'Delivery'){
            data = JSON.stringify({ReportData:ReportData,commentery:checked === true ?'YES':'NO',deliveryIntraDay:false,Free:false}); 
        }
        else{
            data = JSON.stringify({ReportData:ReportData,commentery:checked === true ?'YES':'NO'});
        }


        fetch(`${BASE_URL}/sendtotelegram`, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/json',
                 'Authorization': `Bearer ${loginuser.token}`
            },
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if(res.success === true){
                //    setLoading(false)
                //    window.location.reload();
                setReportCreated(false)
                if(eventType === 'Future'){
                    setLoading(false)
                    setEventChange('Future')
                }
                else if (eventType === 'Options'){
                    setLoading(false)
                    setEventChange('Options')
                }else if (eventType === 'Delivery'){
                    setLoading(false)
                    setEventChange('Delivery')
                }else if (eventType === 'HNI'){
                    setLoading(false)
                    setEventChange('HNI')
                }

                } else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false) 
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);
                }

            })
            .catch(error => {
                setLoading(false) 
                console.error('Error fetching data:', error);
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
            });
        }catch(error){
          setLoading(false)
          setDialogBox(true)
          setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }
    }


    //  this fucntion is used to call submit report on the basis of report type
    const submitreport = async (reportType) => {
    
    console.log("reportcrewated",reportCreated)
    if(reportCreated === false){
        setLoading(true)
        if (reportType === 'futureBuy') {
            
            futureBuyRepportSubmit(reportType);
            
           
        }
        if (reportType === 'futureSell') {
         
            futureSellRepportSubmit(reportType);

            
        }
        if (reportType === 'optionCall') {
         

            optionCallRepportSubmit(reportType);
            
        }
        if (reportType === 'optionPut') {
         

            optionPutRepportSubmit(reportType);
            
        }
        if (reportType === 'deliveryReport') {
           
            deliveryRepportSubmit(reportType);
           
        }
        if (reportType === 'hniReport') {
          
            HNIRepportSubmit(reportType);
            
        }
    }
    else{
        
        setReportAlreadySuccess(true);
        setDialogBox(true);
     
        setTimeout(() => {
            setDialogBox(false);
           setReportAlreadySuccess(false); 
        }, 2500);

    }

    }


    //  this fucntion is used to submit future Buy Report
    const futureBuyRepportSubmit = async (reportType) => {

        try{
        console.log("stockLossRecord",stockLossRecord)
       
        let data = JSON.stringify(futureSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        // console.log("data", data);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('isMCX', true);
    


        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit()
                    setLoading(false)
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true)
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                   
                    

                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);
                    // alert('failed to save report')   
                }
            })
            .catch(error => {
                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
                // alert('failed to save report')
                console.error('Error failed to save report:', error);
            });
        }catch(error){
          setLoading(false)
          setDialogBox(true)
            setShowErrorMsz(true)
            setErrorMessage(`Error: ${error.message}`)
            setTimeout(() => {
              setDialogBox(false)
              setShowErrorMsz(false)
              setErrorMessage('')
            }, 2000);  
        }
    }

    // this function is used to submit future sell report 
    const futureSellRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord",stockLossRecord)
        console.log("report name", reportType)
        let data = JSON.stringify(futureSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('isMCX', true);

        

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit()
                    setLoading(false)
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true)
                  
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false)
            setDialogBox(true)
            setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }
    }

     // this function is used to submit option call report 
    const optionCallRepportSubmit = async (reportType) => {

        try{
        console.log("stockLossRecord",stockLossRecord)
     
        let data = JSON.stringify(optionSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
     
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', false);
        formData.append('free', false);
  

  

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit()
                    setLoading(false)
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true)
                    
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false)
            setDialogBox(true)
            setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }
    }

     // this function is used to submit option put report 
    const optionPutRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord",stockLossRecord)
        console.log("report name", reportType)
        let data = JSON.stringify(optionSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', false);
        formData.append('free', false);

     

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit()
                    setLoading(false);
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true);
                   
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                    
                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setShowErrorMsz(false)
                  setDialogBox(false)
                  setErrorMessage('')
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false)
            setDialogBox(true)
            setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }
    }

     // this function is used to submit delivery  report 
    const deliveryRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord",stockLossRecord)
        console.log("report name", reportType)
        let data = JSON.stringify(deliverySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        // console.log("data", data);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('deliveryIntraDay', false);
        formData.append('free', false);
        formData.append('createdBy', loginuser.user_id);


        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    setLoading(false);
                    onSuccessSubmit()
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true)
                   
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000);  
                }
            })
            .catch(error => {

                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false)
            setDialogBox(true)
            setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }

    }

     // this function is used to submit Hni report 
    const HNIRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord",stockLossRecord)
        console.log("report name", reportType)
        let data = JSON.stringify(deliverySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);


        let formdata = JSON.stringify({eventType:eventType,ReportData:data,ReportName:reportType,imageData:imageBuffer,reportDate:reportDate,selectedExpiryRecord:selectedExpiryRecord,selectedStockRecord:selectedStockRecord,createdBy:loginuser.user_id})

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit()
                    setLoading(false);
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true)
                   
                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false) 
                    }, 2000);
                }else if(res.status === 403){ 
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                  else if(res.status === 401){
                    setTimeout(()=>{
                      localStorage.clear()
                       navigate('/login')
                    },3000) 
                  }
                else{
                    setLoading(false)
                    setDialogBox(true)
                    setShowErrorMsz(true)
                    setErrorMessage(`Error: ${res.message}`)
                    setTimeout(() => {
                      setDialogBox(false)
                      setShowErrorMsz(false)
                      setErrorMessage('')
                    }, 2000); 
                }
            })
            .catch(error => {

                setLoading(false)
                setDialogBox(true)
                setShowErrorMsz(true)
                setErrorMessage(`Error: ${error.message}`)
                setTimeout(() => {
                  setDialogBox(false)
                  setShowErrorMsz(false)
                  setErrorMessage('')
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false)
            setDialogBox(true)
            setShowErrorMsz(true)
          setErrorMessage(`Error: ${error.message}`)
          setTimeout(() => {
            setDialogBox(false)
            setShowErrorMsz(false)
            setErrorMessage('')
          }, 2000);
        }
    }

    return (

        <>
            <div>
                <div className='ReportshowDiv'>
                {loading ?
            <div style={{   
                position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            }}>
              <Loading />
            </div> : null}
                
                    {eventType === 'Future'&& futureSectionState.futureReportType === 'BUY' ?
                       ( <>
                            <div id="futureBuy" className='futureBuy'>
                                <FutureBuyReport reportData={futureSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />


                            </div>

                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button" onClick={() => { submitreport('futureBuy') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} onClick={() => { futurebuydownloadPDF('futureBuy', formattedDate, formattedTime) }} disabled={!isSaveReportSuccessful || imageBuffer === ''}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} onClick={sendtotelegram} disabled={!isSaveReportSuccessful || imageBuffer === ''}>
                                    <i className="pi pi-send"></i> Send To Telegram</button>
          
          </div>
                           
                        </>) : null}



                    {eventType === 'Future'&& futureSectionState.futureReportType === 'Sell' ?
                        (<>
                            <div id="futureSell" className='futureSell'>
                                <FutureSellReport reportData={futureSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button" onClick={() => { submitreport('futureSell') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={()=>{futureselldownloadPDF('futureSell', formattedDate, formattedTime)}}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                        <i className="pi pi-send"></i>Send To Telegram</button>
                                </div>
                            
                        </>) : null}

                    {eventType === 'Options' && optionSectionState.optionReportType === 'CALL' ?
                        (<>
                            <div id="optionCall" className='optionCall'>
                                <OptionCallReport reportData={optionSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button"  onClick={() => { submitreport('optionCall') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={()=>{optioncalldownloadPDF('optionCall', formattedDate, formattedTime)}}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                        <i className="pi pi-send"></i>Send To Telegram</button>
                                </div>
                          
                        </>) : null}

                    {eventType === 'Options' && optionSectionState.optionReportType === 'PUT' ?
                        (<>
                            <div id="optionPut" className='optionPut'>
                                <OptionsPutReport reportData={optionSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button"  onClick={() => { submitreport('optionPut') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={()=>{optionputdownloadPDF('optionPut', formattedDate, formattedTime)}}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                        <i className="pi pi-send"></i>Send To Telegram</button>
                                </div>

                        </>) : null}
                    {eventType === 'Delivery' && deliverySectionState.deliveryReportType === 'BUY' ?
                        (<>
                            <div id="deliveryReport" className='deliveryReport'>
                                <DeliveryReport reportData={deliverySectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button" onClick={() => { submitreport('deliveryReport') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={()=>{deliveryreportdownloadPDF('deliveryReport', formattedDate, formattedTime)}}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                        <i className="pi pi-send"></i>Send To Telegram</button>
                                </div>
                        
                        </>)
                        : null}

                    {eventType === 'HNI' && deliverySectionState.deliveryReportType === 'BUY' ?
                        (<>
                            <div id="hniReport" className='hniReport'>
                                <DeliveryReport reportData={deliverySectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                    <button style={{cursor: imageBuffer === '' ?'not-allowed':'pointer'}} type="button" onClick={() => { submitreport('hniReport') }} disabled={imageBuffer === ''}>
                                        <i className="pi pi-save"></i>Save Report
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={()=>{deliveryreportdownloadPDF('hniReport', formattedDate, formattedTime)}}>
                                        <i className="pi pi-download"></i>Download
                                    </button>
                                    <button type="button" style={{cursor: !isSaveReportSuccessful || imageBuffer === '' ?'not-allowed':'pointer'}} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                        <i className="pi pi-send"></i>Send To Telegram</button>
                                </div>
                        
                        </>)
                        : null}

                </div>


                <Dialog
              open={dialogBox}
              onClose={() => {
                setDialogBox(false);
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <div>
                    {ReportError ? (
                      <span>
                        <i className="pi pi-exclamation-circle"  style={{ color: "#FF6060" }}></i><br/>
                        Fail To Save Report.
                      </span>
                    ) : null}

                   {ReportSuccess ? (
                      <span>
                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br/>
                       Report Successfully Saved. 
                      </span>
                    ) : null}
                    
                    {ReportAlreadySuccess ? (
                      <span>
                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br/>
                       Report Already Saved. To Create New Report Please Refresh The Page Or Send Created Report to Telegram 
                      </span>
                    ) : null}
                    {showErrorMsz ? (
                      <span>
                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br/>
                       {errorMessage}
                      </span>
                    ) : null}
                  </div>
                </DialogContentText>
              </DialogContent>
            </Dialog>




            </div>

           
        </>
    );
};

export default Report;
